import styled from "styled-components";

export const Button = styled.button`
    border-radius: 16px;
    background: #8540DD;
    color: #FFF;
    padding: 6px 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    text-wrap: nowrap;
    font-size: 13px;
`;